<nav class="navbar fixed-top d-flex flex-row align-items-center">
  <!-- <div class="d-flex flex-row align-items-center"> -->
    <div class="d-flex align-items-center navbar-left">
      <a (click)="menuButtonClick($event, sidebar.menuClickCount, sidebar.containerClassnames); false;"
        href="javascript:;" class="menu-button d-none d-md-block">
        <svg class="main" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 17">
          <rect x="0.48" y="0.5" width="7" height="1" />
          <rect x="0.48" y="7.5" width="7" height="1" />
          <rect x="0.48" y="15.5" width="7" height="1" />
        </svg> {{" "}}
        <svg class="sub" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17">
          <rect x="1.56" y="0.5" width="16" height="1" />
          <rect x="1.56" y="7.5" width="16" height="1" />
          <rect x="1.56" y="15.5" width="16" height="1" />
        </svg>
      </a>

      <a (click)="mobileMenuButtonClick($event, sidebar.containerClassnames)" href="javascript:;"
        class="menu-button-mobile d-xs-block d-sm-block d-md-none">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 17">
          <rect x="0.5" y="0.5" width="25" height="1" />
          <rect x="0.5" y="7.5" width="25" height="1" />
          <rect x="0.5" y="15.5" width="25" height="1" />
        </svg>
      </a>
    </div>

    <a class="navbar-logo" [routerLink]="adminRoot">
      <span class="logo d-none d-xs-block"></span>
      <span class="logo-mobile d-block d-xs-none"></span>
    </a>

    <div class="navbar-right">
      <div class="header-icons d-inline-block align-middle">

        <div class="user d-inline-block">
          <span>
            <img alt="Profile Picture" [src]="dpCompany" onerror="this.src='/assets/img/profiles/user.png'"
              style="width: 80px; height: 65px;" />
          </span>
        </div>

        <div class="d-none d-md-inline-block align-text-bottom mr-1">
          <div class="custom-control custom-switch" tooltip="Dark Mode" placement="left">
            <input type="checkbox" class="custom-control-input" id="darkModeSwitch" [checked]="isDarkModeActive"
              (change)="onDarkModeChange($event)">
            <label class="custom-control-label" for="darkModeSwitch"></label>
          </div>
        </div>

        <button style="cursor: pointer !important;" class="header-icon btn btn-empty d-none d-sm-inline-block"
          data-toggle="tooltip" title="ToDo" data-placement="bottom" type="button" id="fullScreenButton"
          (click)="fullScreenClick()">
          <i *ngIf="!isFullScreen" class="simple-icon-size-fullscreen"></i>
          <i *ngIf="isFullScreen" class="simple-icon-size-actual"></i>
        </button>

      </div>

      <div class="user d-inline-block" dropdown>
        <button class="btn btn-empty p-0" type="button" dropdownToggle>
          <span class="name">{{displayName}}</span>
          <span>
            <img alt="Profile Picture" [src]="dpImage" onerror="this.src='/assets/img/profiles/user.png'" />
          </span>
        </button>

        <div class="dropdown-menu dropdown-menu-right mt-3" *dropdownMenu role="menu">
          <a class="dropdown-item c-pointer" (click)="openModalAdd(addNewModal)">Change Password</a>
          <li class="divider dropdown-divider"></li>
          <a class="dropdown-item c-pointer" (click)="onSignOut()">Sign out</a>
        </div>
      </div>

    </div>
  <!-- </div> -->
</nav>

<ng-template #addNewModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Change Password</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon3">Previous Password</span>
      </div>
      <input [type]="showold ? 'text' : 'password'" class="form-control" id="oldpassword" id="oldpasswordField"
        style="height: 37px;border-right: none;" aria-describedby="basic-addon3" autocomplete="off">
      <div class="input-group-prepend">
        <span class="eyeSpan"><i [ngClass]="showold ? 'simple-icon-eye eye-btn' : 'simple-icon-eye eye-btn'"
            id="togglePassword" (click)="textoldPassword()"></i> </span>
      </div>
    </div>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon3"> New Password</span>
      </div>
      <input [type]="show ? 'text' : 'password'" class="form-control" id="password" id="passwordField"
        style="height: 37px;border-right: none;" aria-describedby="basic-addon3" autocomplete="off">
      <div class="input-group-prepend">
        <span class="eyeSpan"><i [ngClass]="show ? 'simple-icon-eye eye-btn' : 'simple-icon-eye eye-btn'"
            id="togglePassword" (click)="textPassword()"></i> </span>
      </div>
    </div>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon3">Re-Type Password</span>
      </div>
      <input [type]="showre ? 'text' : 'password'" class="form-control" id="repassword" id="repasswordField"
        aria-describedby="basic-addon3" style="height: 37px;border-right: none;" autocomplete="off">
      <div class="input-group-prepend">
        <span class="eyeSpan"><i [ngClass]="showre ? 'simple-icon-eye eye-btn' : 'simple-icon-eye eye-btn'"
            id="togglePassword" (click)="textRePassword()"></i> </span>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="submit" (click)="Submit()" class="btn btn-primary">Save</button>
  </div>
</ng-template>

<ng-template #modalmessage>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{caption}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefMessage.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>{{msg}}</p>
  </div>
  <div class="modal-footer">
    <button type="submit" (click)="OK()" class="btn btn-primary">OK</button>
  </div>
</ng-template>